import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
import { useHotkeys } from "react-hotkeys-hook";
import { Key } from "ts-key-enum";
import { useAnalytics } from "use-analytics";
import clamp from "~/shared/utils/clamp";
import EquipmentPanel from "./EquipmentSection";
import recipe from "./recipe.json";
import { Description, IngredientsPanel, LeftPanel, Notes, PageContent, PageContentInnerGrid, PageHeading, StepsPanel, } from "./styled";
const DemoRecipePage = () => {
    const analytics = useAnalytics();
    const containerRef = useRef(null);
    useEffect(() => {
        analytics.page({ title: "Demo Recipe" });
    }, [analytics]);
    const ingredients = Object.fromEntries(recipe.ingredients.map((v) => [v.id, v]));
    const [activeStep, setActiveStep] = useState(null);
    useHotkeys([Key.ArrowDown, Key.ArrowRight], (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (activeStep === null) {
            setActiveStep(0);
            return;
        }
        setActiveStep(clamp(activeStep + 1, 0, recipe.steps.length - 1));
    });
    useHotkeys([Key.ArrowUp, Key.ArrowLeft], (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (activeStep !== null) {
            setActiveStep(clamp(activeStep - 1, 0, recipe.steps.length - 1));
        }
    });
    useHotkeys(["x"], (event) => {
        event.preventDefault();
        event.stopPropagation();
        setActiveStep(null);
    });
    const stepIngredients = activeStep === null ? [] : recipe.steps[activeStep].ingredientHighlights;
    return (_jsx(PageContent, { ref: containerRef, children: _jsxs(PageContentInnerGrid, { children: [_jsx(PageHeading, { children: recipe.title }), _jsx(Description, { children: recipe.description }), _jsx(LeftPanel, { children: _jsxs("div", { style: { position: "sticky", top: 0 }, children: [_jsx(IngredientsPanel, { activeStep: activeStep, ingredients: recipe.ingredients, stepIngredients: stepIngredients }), _jsx(EquipmentPanel, { equipment: recipe.equipment })] }) }), _jsx(StepsPanel, { activeStep: activeStep, ingredients: ingredients, onActiveStepChange: setActiveStep, steps: recipe.steps }), _jsx(Notes, { children: "Hello" }), _jsx("div", { children: _jsx("button", { onClick: () => {
                            throw new Error("uncaught test error");
                        }, children: "Force Rollbar Error" }) })] }) }));
};
export default DemoRecipePage;
